import { useState, useRef } from 'react';
import LoadingSpinner from '../components/layout/LoadingSpinner';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import {
    ACTIVE_TEACH_HELP_AND_FAQ_URL,
    BUILDR_TEACH_HELP_AND_FAQ_URL,
} from '../constants';

const HelpAndFAQ = () => {
    const product = useSelector((state: RootState) => state.product);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const url =
        product === 'Buildr'
            ? BUILDR_TEACH_HELP_AND_FAQ_URL
            : ACTIVE_TEACH_HELP_AND_FAQ_URL;
    const [isLoading, setIsLoading] = useState(true);

    const handleLoad = () => {
        setIsLoading(false);
    };

    return (
        <div
            className="w-full h-full"
            style={{
                padding: '0.5rem 0.5rem 0 0.6rem',
            }}
        >
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                    <LoadingSpinner />
                </div>
            )}
            <iframe
                ref={iframeRef}
                className="content-iframe w-full h-full transition-opacity duration-500 ease-in-out"
                title="HelpAndFAQ"
                src={url}
                onLoad={handleLoad}
                style={{
                    opacity: isLoading ? 0 : 1,
                }}
            ></iframe>
        </div>
    );
};

export default HelpAndFAQ;
